import { render } from "./PageDoubleGrid.vue?vue&type=template&id=6f3ae8e6"
import script from "./PageDoubleGrid.vue?vue&type=script&lang=js"
export * from "./PageDoubleGrid.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/api-staging.champagne-booking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__